export default __webpack_public_path__ + "static/media/aniket.57914450.jpeg";